module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/terms.json
// module id = 411
// module chunks = 89335538696419